<div class="error-snackbar">
        <mat-icon class="icon" style="vertical-align: auto;" rel="preload">error</mat-icon>
        <p class="error-text">Error occured. Please try again.</p>
</div>

